import React from 'react'

// Types
import { ModalState } from '../types'

// Context
import ModalContext, { initialState } from './ModalContext'

export default (
  WrappedComponent: React.ComponentType
): any => class NavigationContainer extends React.Component {

  state: ModalState = initialState

  constructor(props: any) {
    super(props)

    this.state.actions = {
      openModal: this.openModal,
      closeModal: this.closeModal,
    }
  }

  openModal = async (content: React.ReactNode) => {
    this.setState({ content })
  }

  closeModal = () => {
    this.setState({ content: null })
  }

  render() {
    return (
      <ModalContext.Provider value={this.state}>
        <WrappedComponent {...this.props} />
      </ModalContext.Provider>
    )
  }

}
